import Popover from '@mui/material/Popover';
import PopupState, {bindTrigger, bindPopover} from 'material-ui-popup-state';
import React from 'react';

const PopOver = (props) => {
  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      {(popupState) => (
        <div>
          <div {...bindTrigger(popupState)}>
            {props.popOverButton ? props.popOverButton : ''}
          </div>
          <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            {props.popOverBody ? props.popOverBody : ''}
          </Popover>
        </div>
      )}
    </PopupState>
  );
};
export default PopOver;
